import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "16", height: "20", x: "4", y: "2", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "8", x2: "16", y1: "6", y2: "6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "16", x2: "16", y1: "14", y2: "18", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 10h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 10h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 10h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 14h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 14h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 18h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 18h.01", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Calculator";
const Calculator = memo(themed(Icon));
export {
  Calculator
};
//# sourceMappingURL=calculator.js.map
